module.exports = __webpack_public_path__ + "static/img/bro.8688966.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/bro.gif
// module id = 7lkF
// module chunks = 1